import React from 'react'
import Banniere from './Banniere'
import Navbar from './Navbar'

function Menu() {
  return (
    <div>
        <Banniere />
        <Navbar />
    </div>
  )
}

export default Menu;